import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

export const AccessDeniedRoute = ({ condition, children }: { condition: boolean; children: ReactElement }) => {
    if (!condition) return <Navigate to="/access-denied" replace />;
    return children;
};
